<div class="title_div">
    <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="proj_id d-flex">
            <div class="title_sub_div_1 mt-1">Part Alert</div>
        </div>
        <div class="d-flex justify-content-end">

            <div class="title_sub_div_1 mt-1 mr-1">
                <i class="fa fa-home" (click)="home()" title="Dashboard"></i>
            </div>

        </div>
    </div>
</div>
<div class="d-flex align-items-start mb-3 w-100">


    <div class="custom-card-small custom-card-open-projects" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
            <div class="text-block">
                <div class="custom-card-number-small">{{ partsDetails?.length || 0 }}</div>
                <div class="custom-card-text-small">Total Parts </div>
            </div>
        </div>
        <span class="fa fa-folder-open card-icon-right"></span>
    </div>

    <div class="custom-card-small custom-card-open-projects" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">

            <div class="text-block">
                <div class="custom-card-number-small">{{ uniquePartsCount }}</div>
                <div class="custom-card-text-small">Unique Parts</div>
            </div>

            <span class="fa fa-gem card-icon-right"></span>

        </div>
    </div>

    <div class="custom-card-small custom-card-open-projects" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">

            <div class="text-block">
                <div class="custom-card-number-small">{{ availablePartsCount }}</div>
                <div class="custom-card-text-small">Available</div>
            </div>

            <span class="fa fa-check-circle card-icon-right"></span>

        </div>
    </div>

    <div class="ml-auto">
        <button type="button" class="btn btn-outline-primary btn-sm" style="margin-right: 9px;"
            title="Add part number for alert" (click)="openPartModel(addPartModal)">
            <span class="fa fa-plus"></span>
            Add Part
        </button>

    </div>

</div>

<div class="table-responsive gd_main_div_mobile">
    <table class="table table-striped custom-hover">
        <thead>
            <!-- Column Headers -->
            <tr>
                <th *ngFor="let col of tableHeaders; let i = index">
                    {{ col.label }}
                    <i class="fa fa-chevron-down ms-1" style="cursor:pointer" (click)="toggleSearch(i)"></i>
                </th>
                <th>Action</th> <!-- Static Action header -->
            </tr>

            <!-- Filter Inputs -->
            <tr *ngIf="showSearch">
                <th *ngFor="let col of tableHeaders; let i = index">
                    <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                        [(ngModel)]="searchValues[i]" (input)="filterData(searchValues[i])"
                        placeholder="Search {{ col.label }}" />
                </th>
                <th></th> <!-- No filter for Action column -->
            </tr>
        </thead>

        <!-- <tbody>
            <tr *ngFor="let row of filteredPartsDetails; let i = index">
                <td *ngFor="let col of tableHeaders">
                    <ng-container *ngIf="col.key === 'status'; else normalCell">
                        {{ row[col.key] }}
                        <i *ngIf="row[col.key] === 'Available'" class="fa fa-circle-info text-primary ms-2"
                            title="View Details" style="cursor: pointer" (click)="viewStatusDetails(row)">
                        </i>
                    </ng-container>
                    <ng-template #normalCell>
                        {{ col.key === 'frequency_id' ? getFrequencyLabel(row[col.key]) : row[col.key] }}
                    </ng-template>
                </td>

                <td>
                    <i class="fa fa-trash text-danger" (click)="deleteModel(deletemod, i)"></i>
                </td>
            </tr>
        </tbody> -->
        <tbody>
            <tr *ngFor="let row of filteredPartsDetails; let i = index">
                <td *ngFor="let col of tableHeaders">
                    <ng-container *ngIf="col.key === 'status'; else normalCell">
                        <span [ngClass]="{
  'status-available': row[col.key]?.toLowerCase() === 'available',
  'status-pending': row[col.key]?.toLowerCase() === 'pending'
}">
                            {{ row[col.key] }}
                        </span>

                        <i *ngIf="row[col.key] === 'Available'" class="fa fa-circle-info text-primary ms-2"
                            title="View Details" style="cursor: pointer" (click)="viewStatusDetails(row)">
                        </i>
                    </ng-container>

                    <ng-container *ngIf="col.key === 'frequency_id' && row[col.key]">
                        <span class="frequency-text">{{ getFrequencyLabel(row[col.key]) }}</span>
                    </ng-container>

                    <ng-template #normalCell>
                        {{ col.key !== 'frequency_id' ? row[col.key] : '' }}
                    </ng-template>
                    <ng-template #normalCell>
                        <ng-container *ngIf="col.key === 'sourcing_type'">
                            <span *ngIf="Array.isArray(row[col.key])">
                                {{ row[col.key].join(', ') }}
                            </span>
                            <span *ngIf="!Array.isArray(row[col.key])">
                                {{ row[col.key] }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="col.key !== 'sourcing_type'">
                            {{ col.key === 'frequency_id' ? getFrequencyLabel(row[col.key]) : row[col.key] }}
                        </ng-container>
                    </ng-template>

                </td>

                <td>
                    <i class="fa fa-trash text-danger" (click)="deleteModel(deletemod, i)"></i>
                </td>
            </tr>
        </tbody>

    </table>
</div>



<ng-template #addPartModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title">Add Part Number</h6>
    </div>
    <div class="form-group modalformGroup">

        <div class="container">

            <form [formGroup]="partForm">
                <div class="row g-3">

                    <!-- Project Name Dropdown -->
                    <div class="col-md-4" [formGroup]="partForm">
                        <label for="projectName" class="form-label">Project Name</label>
                        <select id="projectName" class="form-control form-select-lg" formControlName="projectName"
                            (change)="onSelectProject()">
                            <option value="" disabled>Select Project</option>
                            <option *ngFor="let pro of projectNameDetails" [value]="pro.projectName">
                                {{ pro.projectName }}
                            </option>
                        </select>
                    </div>

                    <!-- Version Id Dropdown -->
                    <div class="col-md-4">
                        <label for="versionId" class="form-label">Version Id</label>
                        <select id="versionId" class="form-control form-select-lg" formControlName="version_id"
                            (change)="onSelectVersion()">
                            <option value="" disabled>Select Version</option>
                            <option *ngFor="let ver of availableVersions" [value]="ver">
                                {{ ver }}
                            </option>
                        </select>
                    </div>




                    <!-- <div class="col-md-4">
                        <label for="internalPartNo" class="form-label">Internal Part No.</label>
                        <input type="text" id="internalPartNo" class="form-control" formControlName="internalPartNo" />
                        <div *ngIf="partForm.get('internalPartNo')?.invalid && partForm.get('internalPartNo')?.touched"
                            class="text-danger">
                            Internal Part No. is required.
                        </div>
                    </div> -->
                    <div class="col-md-4">
                        <label for="internalPartNo" class="form-label">Internal Part No.</label>
                        <!-- <select id="internalPartNo" class="form-control" formControlName="internalPartNo">
    <option value="" disabled>Select Internal Part</option>
    <option *ngFor="let part of internalPartList" [value]="part.internalPartNo">
      {{ part.internalPartNo }} 
    </option>
  </select> -->
                        <select id="internalPartNo" class="form-control" formControlName="internalPartNo"
                            (change)="onSelectInternalPart()">
                            <option value="" disabled>Select Internal Part</option>
                            <option *ngFor="let part of internalPartList" [value]="part.internalPartNo">
                                {{ part.internalPartNo }}
                            </option>
                        </select>

                        <div *ngIf="partForm.get('internalPartNo')?.invalid && partForm.get('internalPartNo')?.touched"
                            class="text-danger">
                            Internal Part No. is required.
                        </div>
                    </div>



                    <div class="col-md-4">
                        <label for="MPN" class="form-label">MPN</label>
                        <input type="text" id="MPN" class="form-control" formControlName="MPN" />
                        <div *ngIf="partForm.get('MPN')?.invalid && partForm.get('MPN')?.touched" class="text-danger">
                            MPN is required.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="manufacturer" class="form-label">Make</label>
                        <input type="text" id="manufacturer" class="form-control" formControlName="manufacturer" />
                        <div *ngIf="partForm.get('manufacturer')?.invalid && partForm.get('manufacturer')?.touched"
                            class="text-danger">
                            Make is required.
                        </div>
                    </div>



                    <div class="col-md-4">
                        <label for="uom" class="form-label">UOM</label>
                        <input type="text" id="uom" class="form-control" formControlName="uom" />
                        <div *ngIf="partForm.get('uom')?.invalid && partForm.get('uom')?.touched" class="text-danger">
                            UOM is required.
                        </div>
                    </div>


                    <!-- Required Quantity -->
                    <div class="col-md-4">
                        <label for="requiredQuantity" class="form-label">Required Quantity</label>
                        <input type="number" id="requiredQuantity" class="form-control"
                            formControlName="requiredQuantity" />
                        <div *ngIf="
                    partForm.get('requiredQuantity')?.invalid &&
                    partForm.get('requiredQuantity')?.touched
                  " class="text-danger">
                            Required quantity must be greater than 0.
                        </div>
                    </div>

                    <!-- Frequency -->
                    <div class="col-md-4">
                        <label for="frequency" class="form-label">Frequency</label>
                        <select id="frequency" class="form-control" formControlName="frequency">
                            <option *ngFor="let option of frequencyOptions" [ngValue]="option">
                                {{ option.scheduleType }}
                            </option>
                        </select>
                    </div>
                    <!-- <div class="col-md-12 mt-3" formGroupName="sourcingType">
                        <label class="form-label">Sourcing Type</label>
                        <div class="sourcing-type-group">
                        
                            <div class="form-check" *ngFor="let type of ['nexar', 'vendor', 'offline']">
                                <input type="checkbox" class="form-check-input" [id]="type" [formControlName]="type" />
                                <label class="form-check-label text-capitalize" [for]="type">
                                    {{
                                    {
                                    'nexar': 'Consolidator',
                                    'vendor': 'Direct',
                                    'offline': 'Offline'
                                    }[type]
                                    }}
                                </label>
                            </div>

                        </div>

                        <div *ngIf="partForm.get('sourcingType')?.invalid && partForm.get('sourcingType')?.touched"
                            class="text-danger">
                            Please select at least one sourcing type.
                        </div>
                    </div> -->

<div class="col-md-12 mt-3" formGroupName="sourcingType"
     [ngClass]="{'border border-danger p-2 rounded': partForm.get('sourcingType')?.invalid && (partForm.get('sourcingType')?.touched || partForm.get('sourcingType')?.dirty)}">

  <label class="form-label">Sourcing Type <span class="text-danger">*</span></label>
  <div class="sourcing-type-group">
    <div class="form-check" *ngFor="let type of ['nexar', 'vendor', 'offline']">
      <input type="checkbox" class="form-check-input" [id]="type" [formControlName]="type" (change)="partForm.get('sourcingType')?.markAsTouched()" />
      <label class="form-check-label text-capitalize" [for]="type">
        {{
          {
            'nexar': 'Consolidator',
            'vendor': 'Direct',
            'offline': 'Offline'
          }[type]
        }}
      </label>
    </div>
  </div>

  <div *ngIf="partForm.get('sourcingType')?.invalid && (partForm.get('sourcingType')?.touched || partForm.get('sourcingType')?.dirty)"
      class="text-danger mt-1">
    Please select at least one sourcing type.
  </div>
</div>


                </div>

                <!-- Action Buttons -->
                <div class="d-flex justify-content-end mt-3">
                    <!-- <button type="submit" class="btn btn-outline-primary btn-sm mr-2" (click)="addPart()"
                        [disabled]="partForm.invalid">
                        Add Part
                    </button> -->
                    <button type="submit"
        class="btn btn-outline-primary btn-sm mr-2"
        (click)="addPart()"
        [disabled]="partForm.invalid">
  Add Part
</button>

                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="closeModal()">
                        Close
                    </button>
                </div>
            </form>
        </div>
        <!-- </div> -->
    </div>
</ng-template>

<ng-template #deletemod let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Confirm Delete</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        Are you sure you want to delete this item?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onYesToDelete()">Yes, Delete</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    </div>
</ng-template>

<!-- Custom Modal -->
<div *ngIf="showModal" class="custom-modal-overlay">
    <div class="custom-modal-content">
        <div class="custom-modal-header">
            <h5>Part Availability </h5>
            <span class="close-button" (click)="close()">&times;</span>
        </div>

        <div class="custom-modal-body">
            <div class="table-info-block mb-3">
                <p><strong>MPN:</strong> {{ selectedPart?.mpn }}</p>
                <p><strong>Make:</strong> {{ selectedPart?.manufacturer }}</p>
                <p><strong>Project Name:</strong> {{ selectedPart?.project_name }}</p>
            </div>
            <table class="table table-striped custom-hover w-100 mt-1">
                <thead class="table-light">
                    <tr>
                        <th>Supplier</th>
                        <th>Availability</th>
                        <th>Price</th>
                        <th>UOC</th>
                        <th> SPQ</th>
                        <th> MOQ </th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of selectedPart?.supplier_availability">
                        <td>
                            <a *ngIf="item.clickUrl" [href]="item.clickUrl" target="_blank" rel="noopener noreferrer">
                                {{ item.supplier }}
                            </a>
                            <span *ngIf="!item.clickUrl">{{ item.supplier }}</span>
                        </td>
                        <td>{{ item.TotalAvail }}</td>
                        <td>{{ item.Price }}</td>
                        <td>{{ item.Currency }}</td>
                        <td>{{ item.Closest_Quantity }}</td>
                        <td>{{ item.MOQ }}</td>
                    </tr>
                </tbody>

            </table>

        </div>
    </div>
</div>